export default __webpack_public_path__ + "static/media/_cubo5x5.2c9848b8.png";